import { Route, Routes } from "react-router-dom";
import HelpdeskModule from ".";

const HelpdeskRoute = () => {
  return (
    <Routes>
      <Route path="/issues/:issueId" element={<HelpdeskModule />} />
      <Route path="/issues" element={<HelpdeskModule />} />
      <Route path="/*" element={<HelpdeskModule />} />
    </Routes>
  );
};

export default HelpdeskRoute;
